import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLearner } from '../../hooks/useLearner';
import useFocusOnMount from '../../hooks/useFocusOnMount';
import audioManager from '../../lib/audioManager';
import CloudBand from '../../components/common/CloudBand';
import s from './WelcomePage.module.css';

export default function WelcomePage() {
  const { t } = useTranslation();
  const mainRef = useFocusOnMount();
  const navigate = useNavigate();
  const { data: activeLearner } = useLearner();
  const childName = activeLearner?.name || '';

  // Onboarding BGM (audio-system.md). The Welcome screen is the warm first-launch
  // mount point for the single onboarding track; handleStart navigates to the map,
  // whose biome BGM crossfades this out.
  useEffect(() => {
    audioManager.playBGM('onboarding', 'onboarding');
  }, []);

  function handleStart() {
    navigate('/', { replace: true });
  }

  return (
    <main className={s.page} ref={mainRef} tabIndex={-1}>
      {/* Full-bleed hero image */}
      <img
        src="/assets/welcome-hero.webp"
        alt=""
        className={s.heroImg}
        aria-hidden="true"
      />

      {/* Cloud-band at the hero/teal seam */}
      <CloudBand variant="teal" className={s.cloudBand} />

      {/* Teal fill block */}
      <div className={s.tealFill} />

      {/* Content */}
      <div className={s.content}>
        <div className={s.textBlock}>
          <h1 className={s.pageTitle}>
            {t('welcome.greeting', { name: childName })}
          </h1>
          <p className={s.subtitle}>{t('welcome.subtitle')}</p>
        </div>

        <button type="button" className={s.startBtn} onClick={handleStart}>
          {t('welcome.start')}
        </button>
      </div>
    </main>
  );
}
